import _ from 'lodash'
import { currentApp } from './primitive-selector'
import { getRiders } from 'e-submission/sagas/policy-payload/rider-selector'
import VALUES from 'core/data-model/constants/values'

export const quickQuote = (state) => {
  const useQuickQuotePartnerApi = currentApp('quickQuote.biProps.usePartnerApi')(state)
  const useLegacySubmission = currentApp('quickQuote.selectedDisplayProduct.useLegacySubmission')(state)
  let useSubmissionPartnerApi = false
  if (useQuickQuotePartnerApi && !_.isNil(useLegacySubmission)) {
    useSubmissionPartnerApi = !useLegacySubmission
  }
  let category, basicPlanCode, basicPlanName, sumAssured, totalPremium, totalRiderPremium, paymentMethod
  let loanPeriod, loanAmount, interestRate, sumAssuredContract

  const selectedRiders = getRiders(state)
  const riders = selectedRiders
    ? getRiders(state).map((rider) => ({
        code: rider.code,
        premium: rider.premium,
        selectedPlan: _.omitBy({ planCode: rider.planCode, fullPlanCode: rider.fullPlanCode }, _.isNil),
        sumAssured: rider.sumAssured,
      }))
    : []

  if (useQuickQuotePartnerApi) {
    category = currentApp('quickQuote.biProps.data.category')(state)
    basicPlanCode = currentApp('quickQuote.biProps.data.planCode')(state)
    basicPlanName = currentApp('quickQuote.biProps.data.planName')(state)
    sumAssured = currentApp('quickQuote.biProps.data.coverageValue')(state)
    totalPremium = currentApp('quickQuote.biProps.data.totalPremium')(state)
    totalRiderPremium = riders.reduce((sum, item) => {
      return sum + item.premium
    }, 0)
    loanAmount = currentApp('quickQuote.biProps.data.loanAmount')(state)
    paymentMethod = currentApp('quickQuote.biProps.data.loanPaymentMethod')(state)
    interestRate = currentApp('quickQuote.biProps.data.interestRate')(state)
    sumAssuredContract = currentApp('quickQuote.biProps.data.sumAssuredContract')(state)
    loanPeriod = currentApp('quickQuote.biProps.data.loanPeriod')(state)
  } else {
    category = currentApp('quickQuote.biProps.basicPlan.category')(state)
    basicPlanCode =
      category === VALUES.PA
        ? currentApp('quickQuote.selectedDisplayProduct.basicPlanCode')(state)
        : currentApp('quickQuote.biProps.basicPlan.basicPlanCode')(state)
    basicPlanName = currentApp('quickQuote.biProps.basicPlan.basicPlanName')(state)
    sumAssured = currentApp('quickQuote.biProps.sumAssured')(state)
    totalPremium = currentApp('quickQuote.biProps.totalPremium')(state)
    totalRiderPremium = currentApp('quickQuote.biProps.totalRiderPremium')(state)
    loanPeriod = currentApp('quickQuote.biProps.loanPeriod')(state)
    loanAmount = currentApp('quickQuote.biProps.loanAmount')(state)
    paymentMethod = currentApp('quickQuote.biProps.paymentMethod')(state)
    interestRate = currentApp('quickQuote.biProps.interestRate')(state)
    sumAssuredContract = currentApp('quickQuote.biProps.sumAssuredContract')(state)
  }

  return {
    usePartnerApi: useSubmissionPartnerApi,
    basicPlanCode,
    basicPlanName,
    riders,
    sumAssured,
    totalPremium,
    totalRiderPremium,
    category,
    loanPeriod,
    loanAmount,
    paymentMethod,
    interestRate,
    sumAssuredContract,
  }
}
